import React, { ReactNode } from "react";
import styled from "styled-components";
import Tooltip from "@charty/tooltip";
import { Locale } from "@linkfluence/models/locale";
import { Metric } from "@linkfluence/models/metric";
import { ComparisonPeriod } from "@radarly/models/cards/period";
import { MainUnit, SecondaryUnit } from "@radarly/models/data-units";
import { getContent, getHorizontalBarChartFooter } from "./utils";

interface IProps {
  total: number;
  metric: Metric;
  locale: Locale;
  count: number;
  label: string;
  color?: string;
  content?: ReactNode;
  mainUnit: MainUnit;
  secondaryUnit: SecondaryUnit;
  comparisonPeriod: ComparisonPeriod;
  evolution?: number;
  isHideable?: boolean;
  isHidden?: boolean;
}

const Label = styled.span`
  > span {
    text-transform: lowercase;
  }
`;

const RadarlyWidgetsTooltipHorizontalBarChart = (props: IProps) => {
  const { label, color, locale, count, total, metric } = props;
  return (
    <Tooltip
      color={color}
      label={
        <Label>
          {label} - <span>{getContent(locale, count, total, metric)}</span>
        </Label>
      }
      footer={getHorizontalBarChartFooter(props)}
    />
  );
};

export default RadarlyWidgetsTooltipHorizontalBarChart;
